import React from 'react';
import ReactApexChart from 'react-apexcharts';

type ChartProps = {
	chartData: any[];
	chartOptions: any;
	[x: string]: any;
};

type ChartState = {
	chartData: any[];
	chartOptions: any;
};

class PieChart extends React.Component<ChartProps, ChartState> {
	constructor(props: ChartProps) {
		super(props);
		this.state = {
			chartData: props.chartData || [],
			chartOptions: props.chartOptions || {}
		};
	}

	componentDidMount() {
		this.setState({
			chartData: this.props.chartData,
			chartOptions: this.props.chartOptions
		});
	}

	componentDidUpdate(prevProps: ChartProps) {
		if (
			prevProps.chartData !== this.props.chartData ||
			prevProps.chartOptions !== this.props.chartOptions
		) {
			this.setState({
				chartData: this.props.chartData,
				chartOptions: this.props.chartOptions
			});
		}
	}

	render() {
		const height = this.props.height || '280px';
		return (
			<ReactApexChart
				options={this.state.chartOptions}
				series={this.state.chartData}
				type='pie'
				width='100%'
				height={height}
			/>
		);
	}
}

export default PieChart;
